export enum MiniIframeEvent {
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  GO_BACK = 'GO_BACK',
  ASK_TOKEN = 'ASK_TOKEN',
  ASK_ORIGIN = 'ASK_ORIGIN',
  REFRESH_NEXT_STATE = 'REFRESH_NEXT_STATE',
  REDIRECT_TO_DASHBOARD = 'REDIRECT_TO_DASHBOARD',
  TRACK_PLAYED_ONBOARDING_VIDEO = 'TRACK_PLAYED_ONBOARDING_VIDEO',
  UPDATE_PRIMARY_WABA = 'UPDATE_PRIMARY_WABA',
}
